export enum ProxyApi {
  streaming = 'streaming',
  rest = 'rest',
  rpc = 'rpc'
}

export const STREAMING_API = [
  { label: '/account-balances', value: 'account-balances' },
  { label: '/blocks', value: 'blocks' },
  { label: '/contracts', value: 'contracts' },
  { label: '/deploys', value: 'deploys' },
  { label: '/contract-packages', value: 'contract-packages' },
  { label: '/contract-events', value: 'contract-events' },
  { label: '/ft-token-actions', value: 'ft-token-actions' },
  { label: '/nft-tokens', value: 'nft-tokens' },
  { label: '/nft-token-actions', value: 'nft-token-actions' },
  { label: '/transfers', value: 'transfers' },
  { label: '/transactions', value: 'transactions' }
];

export const REST_API = [
  { label: '/account-info/**', value: 'account-info' },
  { label: '/accounts/**', value: 'accounts' },
  { label: '/auction-metrics', value: 'auction-metrics' },
  { label: '/awaiting-deploys/**', value: 'awaiting-deploys' },
  { label: '/bidders/**', value: 'bidders' },
  { label: '/blocks/**', value: 'blocks' },
  { label: '/centralized-account-info/**', value: 'centralized-account-info' },
  { label: '/contract-packages/**', value: 'contract-packages' },
  { label: '/contract-types', value: 'contract-types' },
  { label: '/contracts/**', value: 'contracts' },
  { label: '/cspr-name-resolutions/**', value: 'cspr-name-resolutions' },
  { label: '/currencies/**', value: 'currencies' },
  { label: '/deploy-execution-types', value: 'deploy-execution-types' },
  { label: '/deploys/**', value: 'deploys' },
  { label: '/ft-token-action-types', value: 'ft-token-action-types' },
  { label: '/ft-token-actions', value: 'ft-token-actions' },
  { label: '/nft-token-action-types', value: 'nft-token-action-types' },
  {
    label: '/nft-token-offchain-metadata-statuses',
    value: 'nft-token-offchain-metadata-statuses'
  },
  { label: '/nft-token-standards', value: 'nft-token-standards' },
  { label: '/purse-urefs/**', value: 'purse-urefs' },
  { label: '/rates/**', value: 'rates' },
  {
    label: '/relative-average-validator-performances',
    value: 'relative-average-validator-performances'
  },
  { label: '/supply/**', value: 'supply' },
  { label: '/validators/**', value: 'validators' }
];

export const RPC_METHODS = [
  { value: 'account_put_deploy', label: 'account_put_deploy' },
  { value: 'account_put_transaction', label: 'account_put_transaction' },
  { value: 'chain_get_block', label: 'chain_get_block' },
  { value: 'chain_get_block_transfers', label: 'chain_get_block_transfers' },
  { value: 'chain_get_era_info_by_switch_block', label: 'chain_get_era_info_by_switch_block' },
  { value: 'chain_get_era_summary', label: 'chain_get_era_summary' },
  { value: 'chain_get_state_root_hash', label: 'chain_get_state_root_hash' },
  { value: 'info_get_chainspec', label: 'info_get_chainspec' },
  { value: 'info_get_deploy', label: 'info_get_deploy' },
  { value: 'info_get_peers', label: 'info_get_peers' },
  { value: 'info_get_reward', label: 'info_get_reward' },
  { value: 'info_get_status', label: 'info_get_status' },
  { value: 'info_get_transaction', label: 'info_get_transaction' },
  { value: 'info_get_validator_changes', label: 'info_get_validator_changes' },
  { value: 'query_balance', label: 'query_balance' },
  { value: 'query_balance_details', label: 'query_balance_details' },
  { value: 'query_global_state', label: 'query_global_state' },
  { value: 'rpc.discover', label: 'rpc.discover' },
  { value: 'speculative_exec', label: 'speculative_exec' },
  { value: 'state_get_account_info', label: 'state_get_account_info' },
  { value: 'state_get_auction_info', label: 'state_get_auction_info' },
  { value: 'state_get_auction_info_v2', label: 'state_get_auction_info_v2' },
  { value: 'state_get_balance', label: 'state_get_balance' },
  { value: 'state_get_dictionary_item', label: 'state_get_dictionary_item' },
  { value: 'state_get_item', label: 'state_get_item' },
  { value: 'state_get_package', label: 'state_get_package' },
  { value: 'state_get_entity', label: 'state_get_entity' }
];
